import { CreditCardTypes } from '../responses/credit.card.response';

export interface IAddCreditCardRequest {

    CVV: number;
    CreditCardNumber: string;
    SetAsDefault: boolean;

    ID: number;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    CardType: CreditCardTypes;
    DateTimeLastUpdate: Date;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;

    UpdateMemberAddress: boolean;

    IsValid(): string[];
    
}

export class AddCreditCardRequest implements IAddCreditCardRequest {

    ID: number;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    CardType: CreditCardTypes;
    DateTimeLastUpdate: Date;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    CreditCardNumber: string;
    CVV: number;
    SetAsDefault: boolean;

    UpdateMemberAddress: boolean;

    IsValid(): string[] {

        let validationErrors = new Array<string>();


        if (this.Address01 == undefined || this.Address01 == "") {
            validationErrors.push("Address 1");
        }

        if (this.City == undefined || this.City == "") {
            validationErrors.push("City");
        }

        if (this.Country == undefined || this.Country == "") {
            validationErrors.push("Country");
        }

        if (this.CVV == undefined || this.CVV < 99) {
            validationErrors.push("CVV");
        }

        if (this.ExpMonth == undefined) {
            validationErrors.push("ExpMonth");
        }

        if (this.ExpYear == undefined) {
            validationErrors.push("ExpYear");
        }

        if (this.FirstName == undefined || this.FirstName == "") {
            validationErrors.push("FirstName");
        }

        if (this.LastName == undefined || this.LastName == "") {
            validationErrors.push("LastName");
        }

        if (this.ZipCode == undefined || this.ZipCode == "") {
            validationErrors.push("PostalCode");
        }

        if (this.State == undefined || this.State == "") {
            validationErrors.push("State");
        }

        if (this.CreditCardNumber == undefined || this.CreditCardNumber == "") {
            validationErrors.push("Number");
        }

        return validationErrors;

    }

}